module.exports = __webpack_public_path__ + "img/cafe.0544ad89.jpg";